
<portal to="overlay" :disabled="!usePortal">
    <div
        class="Modal"
        ref="modal"
        :class="[{ isActive: isActive, 'is-fullscreen': fullscreen }]"
    >
        <div
            class="Modal-Content"
            :class="[
                `is-${size}`,
                {
                    'is-feature-announcement': featureAnnouncementLayout,
                    'is-fullscreen': fullscreen,
                },
            ]"
        >
            <div class="Modal-Header" v-if="!featureAnnouncementLayout && !fullscreen">
                <div class="header-content">
                    <h3 v-if="title">{{ title }}</h3>
                    <slot name="header"></slot>
                </div>
                <button class="close-button" @click="closeModal">
                    <i class="ri-close-line"></i>
                </button>
            </div>
            <div
                v-if="fullscreen && !featureAnnouncementLayout"
                class="Modal-Header--fullscreen"
            >
                <button class="close-button" @click="closeModal">
                    <i class="ri-close-line"></i>
                </button>
            </div>
            <div v-if="featureAnnouncementLayout" class="Modal-Header--minimal">
                <button class="close-button" @click="closeModal">
                    <i class="ri-close-line"></i>
                </button>
            </div>
            <div v-if="featureAnnouncementLayout" class="Modal-Media">
                <slot name="media"></slot>
            </div>
            <div
                class="Modal-Body"
                :class="{ 'is-feature-announcement': featureAnnouncementLayout }"
            >
                <div v-if="featureAnnouncementLayout" class="Modal-TitleSection">
                    <slot name="header">
                        <h3 v-if="title">{{ title }}</h3>
                    </slot>
                </div>
                <p v-if="text">{{ text }}</p>
                <slot></slot>
            </div>
            <div class="Modal-Actions" v-if="hasActions">
                <slot name="actions">
                    <Button
                        v-if="cancel.text"
                        tabindex="0"
                        variant="basic"
                        :class="`is-${cancel.color}`"
                        @onClick="handleAction(cancel.callback)"
                    >
                        {{ cancel.text }}
                    </Button>
                    <Button
                        v-if="action.text"
                        tabindex="0"
                        variant="success"
                        :isLoading="isLoading || action.isLoading"
                        :class="`is-${action.color}`"
                        @onClick="handlePositiveActionClick(action.callback)"
                    >
                        {{ action.text }}
                    </Button>
                </slot>
            </div>
        </div>
        <div class="Backdrop" @click="closeModalOnBackdropClick" />
    </div>
</portal>
